module.exports = __webpack_public_path__ + "img/venus9.145f7bc0.png";